const companyRoleCodeByValue: Record<string, string> = {
  aktuarie: 'AK',
  bolagsman: 'BO',
  'delgivningsbar person (särskild delgivningsmottagare)': 'DELG',
  'extern firmatecknare (ej styrelsemedlem)': 'EFT',
  'extern verkställande direktör (ej styrelsemedlem)': 'EVD',
  'extern vice verkställande direktör (ej styrelsemedlem)': 'EVVD',
  föreståndare: 'FÖ',
  innehavare: 'IN',
  kommanditdelägare: 'KD',
  komplementär: 'KP',
  styrelseledamot: 'LE',
  likvidator: 'LI',
  likvidatorssuppleant: 'LS',
  ordförande: 'OF',
  prokurist: 'PO',
  representant: 'REP',
  revisor: 'REV',
  'huvudansvarig revisor': 'REVH',
  lekmannarevisor: 'REVL',
  revisorssuppleant: 'REVS',
  lekmannarevisorssuppleant: 'REVSL',
  'revisor med tillstånd': 'REVT',
  'aktuarie revisorssuppleant': 'REVST',
  styrelsesuppleant: 'SU',
  'ställföreträdande verkställande direktör': 'SVD',
  'verkställande direktör': 'VD',
  'verkställande ledamot': 'VLE',
  'vice ordförande': 'VOF',
  'vice verkställande direktör': 'VVD',
};

const companyRoleCodes = new Set(Object.values(companyRoleCodeByValue));

export function getCompanyRoleTranslationKey(value: string): string | null {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  const roleCode = companyRoleCodeByValue[trimmedValue.toLocaleLowerCase('sv-SE')]
    ?? (companyRoleCodes.has(trimmedValue.toUpperCase()) ? trimmedValue.toUpperCase() : undefined);

  return roleCode ? `backend.companyRoles.${roleCode}` : null;
}
